import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})

export class TaskService {

    controller = 'Task';
    constructor(private base: BaseService) { }

    getAllCurrentTaskForUser(userId: number): Observable<ApiObjectData> {
        return this.base.getById<ApiObjectData>(`services/app/${this.controller}/GetAllCurrentTaskForUser`, { userId });
    }  
}